import {useQuery} from 'react-query'
import ReactApexChart from 'react-apexcharts';
import { useSelector, useDispatch } from 'react-redux';
import { getActiveStudent, getActiveStudentChartOptions, selectActiveStudentData } from '../../../data/StudyPeriod/studyPeriodSlice';
import {Spinner} from 'react-bootstrap'



const ActiveStudent = () => {
  const activeStudentData = useSelector(selectActiveStudentData);
  const dispatch = useDispatch();
  const chartOptions = getActiveStudentChartOptions();
  
  const {isLoading} = useQuery({
    queryKey: ['activeStudent'],
    queryFn: () => dispatch(getActiveStudent(activeStudentData) as any),
  });

  return (
    <div>
      {isLoading ? (
        <Spinner animation='border' variant='secondary' />
      ) : (
        <div>
          <ReactApexChart
            options={chartOptions as any}
            series={activeStudentData.series}
            type='bar'
            height={350}
          />
        </div>
      )}
    </div>
  );
};

export default ActiveStudent;